<div class="tools row-flex-fix">
  <app-genesys-lane-buttons
    *ngIf="isExpandedMode"
    [integrations]="integrations"
    [openIntegrationPanels]="openIntegrationPanels"
    [isCobrowseAllowed]="isCobrowseAllowed"
    [isCobrowseActive]="isCobrowseActive"
    (toggleIntegration)="toggleIntegration.emit($event)"
    (toggleCobrowse)="toggleCobrowse.emit($event)"
  >
  </app-genesys-lane-buttons>

  <span class="separator"></span>

  <button
    class="tools-icon tools-minimize"
    title="{{ 'workWidgetHeader.minimizeLabel' | translate }}"
    [attr.data-automation-id]="'minimize-button'"
    (click)="minimize.emit()"
  >
    <svg-icon icon="minus"></svg-icon>
  </button>

  <button
    *ngIf="isExpandedMode"
    class="tools-icon tools-collapse"
    [attr.data-automation-id]="'collapse-button'"
    (click)="toggleExpanded.emit()"
  >
    <svg-icon icon="collapse-arrows"></svg-icon>
  </button>

  <button
    *ngIf="!isExpandedMode"
    class="tools-icon tools-expand"
    [attr.data-automation-id]="'expand-button'"
    (click)="toggleExpanded.emit()"
  >
    <svg-icon icon="expand-arrows"></svg-icon>
  </button>
</div>
